import axios from 'axios';
import z from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import { createValidator } from 'functions/validation/zod';

import { ShoppingCartDtoSchema } from '../schemas/ShoppingCartDto';

// No PathParameters

// No QueryParameters

// No RequestBody

const ResponseDataSchema = z.array(z.lazy(() => ShoppingCartDtoSchema));
export type ResponseData = z.infer<typeof ResponseDataSchema>;
const validator = createValidator(ResponseDataSchema);

export async function callApi(): Promise<Optional<ResponseData>> {
	const url: string = SERVICEBASEURL.BACKEND + `/ShoppingCart`;
	return (await axios.get(url).toOptionalFiltered(validator)).map((x) => x.data);
}
